import { auth, db } from '@/firebaseConfig'

const state = {
  currentUser: null,
  scopes: null
}

const getters = {
  currentUser: (state) => {
    return state.currentUser
  },
  userScopes: (state) => {
    if (state.scopes == null) {
      const scopesJSON = localStorage.getItem('scopes')
      if (!scopesJSON) {
        return null
      }
      const cachedScopes = JSON.parse(scopesJSON)
      return cachedScopes
    } else {
      return state.scopes
    }
  }
}

const mutations = {
  setCurrentUser(state, newValue) {
    state.currentUser = newValue
  },
  setCurrentUserScopes(state, newValue) {
    state.scopes = newValue
    localStorage.setItem('scopes', JSON.stringify(newValue))
  }
}

const actions = {
  clearUserData({ commit }) {
    commit('setCurrentUser', null)
    commit('setCurrentUserScopes', null)
  },
  async getCurrentUserScopes({ commit, dispatch }) {
    if (!auth.currentUser) {
      return
    }
    try {
      const userDocSnapshot = await db.collection('users').doc(auth.currentUser.uid).get()
      const scopes = userDocSnapshot.data()?.scopes ?? []
      
      commit('setCurrentUserScopes', scopes)
      await dispatch('getUserCompanies', scopes)
    } catch (error) {
      console.error(error)
    }
    
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
}
